import { Link, useNavigate } from 'react-router-dom';
import cardIcon from '../../assets/img/icon/card_icon.png';
import cardBtnIcon from '../../assets/img/icon/card_icon2.png';

import { MdOutlineAddCard } from "react-icons/md";

const NoCardPage = ({cardIssuingAvailable, completeKyc = false}) => {
  const navigate = useNavigate();
  return completeKyc ? (
    <section className='noCards__page'>
        <div className="noCard__display">
          <img src={cardIcon} alt="icon" width="150px" height="150px" className='img-fluid' />
          <h3> Complete KYC </h3>
          <p> Kindly complete your KYC Tier-2 upgrade to be able to <br/> create and use virtual cards.</p>
          <button onClick={() => {navigate("/user/settings", { state: { activeTab: 'compliance'} });}} className='btn primary__btn'>
              <span> Complete KYC </span>
          </button>
        </div>
    </section>
  ) : (
    <section className='noCards__page'>
        <div className="noCard__display">
            <img src={cardIcon} alt="icon" width="150px" height="150px" className='img-fluid' />
            <h3>No Card Available</h3>

            {cardIssuingAvailable ? <>
              <p>Instantly create a virtual card to make your <br /> payments seamlessly.</p>
              <Link to='step1' className='btn primary__btn'>
                  <MdOutlineAddCard size={25} />
                  {/* <img src={cardBtnIcon} alt="icon" width="20px" height="16px" className='img-fluid' /> */}
                  <span>Create New Card</span>
              </Link>
            </>:<>
              <p>
                Virtual cards issuing is currently not <br /> 
                supported in your region at the moment.
              </p>
            </>}
        </div>
    </section>
  )
}

export default NoCardPage